/**
 * Created by bas.
 */

'use strict';

var gettextWrapper = require('mag-gettext'),
    restartTimer, gettext;

function build ( config ) {
    var result = {
        content: [
            {
                id: 'ntp',
                parent: 'system',
                type: 'option',
                name: gettext('NTP server'),
                description: [
                    {
                        label: gettext('URL') + ':',
                        value: window.core.environment.ntpurl
                    }, {
                        label: '',
                        value: gettext('Setting up the NTP server as a time source to synchronize time on a set-top box via a local or Internet network.')  // eslint-disable-line
                    }
                ],
                icon: 'theme-icon-ntp-server',
                config: {type: 'qwerty'},
                render: config.api.renders.input,
                getter: config.api.getters.environment,
                environment: {
                    ntpurl: 'pool.ntp.org'
                },
                prepareForRender: function ( data, callback ) {
                    this.config.value = data['ntpurl'];
                    callback();
                },
                prepareForSave: function ( value, callback ) {
                    this.environment['ntpurl'] = value;
                    clearTimeout(restartTimer);
                    restartTimer = setTimeout(function () {
                        gSTB.ServiceControl('ntp', 'restart');
                    }, 100);
                    callback(null, function () {
                        //console.log('call setInfo ' + typeof config.api.actions.setInfo);
                        config.api.actions.setInfo({
                            description: [
                                {
                                    label: gettext('URL') + ':',
                                    value: value
                                }, {
                                    label: '',
                                    value: gettext('Setting up the NTP server as a time source to synchronize time on a set-top box via a local or Internet network.')  // eslint-disable-line
                                }
                            ]
                        });
                        if ( result && result.content && result.content[0] && result.content[0].description ) {
                            result.content[0].description[0].value = value;
                        }
                    });
                },
                saver: config.api.savers.environment
            }
        ]
    };

    return result;
}


module.exports = {
    onInit: function ( config, callback ) {
        callback();
    },
    onAppInit: function ( config, callback ) {
        callback(null, {});
    },
    onSettingsInit: function ( config, callback ) {
        gettextWrapper.load({
            name: window.core.environment.language,
            path: config.path + 'lang'
        }, function () {
            gettext = gettextWrapper.gettext;
            callback(null, build(config));
        });
    }
};
